module.exports = __webpack_public_path__ + "img/game-features-pvm-content.759c3bcf.png";